import { General } from '../General';
import { ACATRequests } from '@shared/api/ServiceAPI/ACATRequests/ACATRequests';
import { AchRelationships } from '@shared/api/ServiceAPI/AchRelationships/AchRelationships';
import { Clearing } from '@shared/api/ServiceAPI/Clearing/Clearing';
import { DTCMessages } from '@shared/api/ServiceAPI/DTCMessages/DTCMessages';
import { DailySettlements } from '@shared/api/ServiceAPI/DailySettlements/DailySettlements';
import { Edocs } from '@shared/api/ServiceAPI/Edocs/Edocs';
import { Jobs } from '@shared/api/ServiceAPI/Jobs/Jobs';
import { NetSettlements } from '@shared/api/ServiceAPI/NetSettlements/NetSettlements';
import { Securities } from '@shared/api/ServiceAPI/Securities/Securities';
import { Positions } from '@shared/api/ServiceAPI/Positions/Positions';
import { Audits } from '@shared/api/ServiceAPI/Audits/Audits';
import { AccountBalance } from '@shared/api/ServiceAPI/AccountBalance/AccountBalance';
import { Accounts } from '@shared/api/ServiceAPI/Accounts/Accounts';
import { Transactions } from '@shared/api/ServiceAPI/Transactions/Transactions';
import { Transfers } from '@shared/api/ServiceAPI/Transfers/Transfers';
import { TransferReports } from '@shared/api/ServiceAPI/TransferReports/TransferReports';
import { Lookups } from '@shared/api/ServiceAPI/Lookups/Lookups';
import { ManualApprove } from '@shared/api/ServiceAPI/ManualApprove/ManualApprove';
import { ReportsStore } from '@shared/api/ServiceAPI/ReportsStore/ReportsStore';
import { Schedule } from '@shared/api/ServiceAPI/Schedule/Schedule';
import { SFTPReports } from '@shared/api/ServiceAPI/SFTPReports/SFTPReports';
import { UserGroups } from '@shared/api/ServiceAPI/UserGroups/UserGroups';
import { Users } from '@shared/api/ServiceAPI/Users/Users';
import { DtcReports } from '@shared/api/ServiceAPI/DTCReports/DTCReports';
import { VerificationResult } from './VerificationResult/VerificationResult';
import { UserManagement } from './UserMangement/UserMangement';
import { ClientDetailsManagement } from './ClientDetails/ClientDetails';
import { Orders } from './Order/Order';
import { PreferencesManagement } from './Preferences/Preferences';
import { TradeOrder } from './TradeOrders/TradeOrders';
import { RIANotifications } from './RIANotifications/RIANotifications';
import { RebalancingJob } from './RebalancingJob/RebalancingJob';
import { AssignSecurity } from './AssignSecurity/AssignSecurity';

export class ServiceAPI {
    private static _basePath = General.getClearingUrl();

    public static getMethods() {
        return {
            acatRequests: ACATRequests.getMethods(ServiceAPI._basePath),
            achRelationships: AchRelationships.getMethods(ServiceAPI._basePath),
            accountBalance: AccountBalance.getMethods(ServiceAPI._basePath),
            clearing: Clearing.getMethods(ServiceAPI._basePath),
            dtcMessages: DTCMessages.getMethods(ServiceAPI._basePath),
            dailySettlements: DailySettlements.getMethods(ServiceAPI._basePath),
            eDocs: Edocs.getMethods(ServiceAPI._basePath),
            jobs: Jobs.getMethods(ServiceAPI._basePath),
            netSettlements: NetSettlements.getMethods(ServiceAPI._basePath),
            securities: Securities.getMethods(ServiceAPI._basePath),
            positions: Positions.getMethods(ServiceAPI._basePath),
            audits: Audits.getMethods(ServiceAPI._basePath),
            accounts: Accounts.getMethods(ServiceAPI._basePath),
            transactions: Transactions.getMethods(ServiceAPI._basePath),
            userManagement: UserManagement.getMethods(ServiceAPI._basePath),
            clientDetails: ClientDetailsManagement.getMethods(ServiceAPI._basePath),
            orders: Orders.getMethods(ServiceAPI._basePath),
            preferences: PreferencesManagement.getMethods(ServiceAPI._basePath),
            transfers: Transfers.getMethods(ServiceAPI._basePath),
            transferReports: TransferReports.getMethods(ServiceAPI._basePath),
            lookups: Lookups.getMethods(ServiceAPI._basePath),
            manualApprove: ManualApprove.getMethods(ServiceAPI._basePath),
            reportsStore: ReportsStore.getMethods(ServiceAPI._basePath),
            schedule: Schedule.getMethods(ServiceAPI._basePath),
            sftpReports: SFTPReports.getMethods(ServiceAPI._basePath),
            userGroups: UserGroups.getMethods(ServiceAPI._basePath),
            users: Users.getMethods(ServiceAPI._basePath),
            tradeOrders: TradeOrder.getMethods(ServiceAPI._basePath),
            riaNotifications: RIANotifications.getMethods(ServiceAPI._basePath),
            rebalancingJob: RebalancingJob.getMethods(ServiceAPI._basePath),
            assignSecurity: AssignSecurity.getMethods(ServiceAPI._basePath),
            dtcReports: DtcReports.getMethods(ServiceAPI._basePath),
            verificationResult: VerificationResult.getMethods(ServiceAPI._basePath),
        };
    }
}
